module.exports = __webpack_public_path__ + "img/Frente-47-01 on.25c091a0.png";